// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "../../theme/SwiperOverrides.css";

import * as styles from "./FavouriteDogCardCarousel.module.scss";

import React from "react";
import { A11y, Navigation, Pagination, Virtual } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import FavouriteDogCarouselCard from "../SignPostCards/FavouriteDogCarouselCard/FavouriteDogCarouselCard";

export interface FavouriteDogCardCarouselProps {
	dogs: DogsTrust.DogData[];
}

export const FavouriteDogCardCarousel: React.FC<
	FavouriteDogCardCarouselProps
> = ({ dogs }) => {
	return (
		<div className={styles.wrapper}>
			<Swiper
				key={dogs.length}
				className={styles.swiper}
				modules={[Virtual, Navigation, A11y, Pagination]}
				edgeSwipeThreshold={10}
				threshold={0}
				grabCursor={false}
				draggable={false}
				longSwipes={true}
				resistance={false}
				shortSwipes={false}
				noSwiping
				centeredSlides={true}
				initialSlide={0}
				pagination={{ clickable: true }}
				preventClicks
				breakpoints={{
					320: {
						slidesPerView: 3,
						enabled: dogs.length > 3,
						spaceBetween: 2,
						autoplay: false,
						centeredSlides: false,
						loop: false,
					},
				}}
			>
				{dogs.length > 0 &&
					dogs.map((dog) => (
						<SwiperSlide key={dog.apiKey}>
							<FavouriteDogCarouselCard dog={dog} />
						</SwiperSlide>
					))}
			</Swiper>
		</div>
	);
};

export default FavouriteDogCardCarousel;
